<template>
    <div>
        <!-- 检索条件 -->
        <div class="fixedRight">
            <el-form :inline="true" @submit.native.prevent>
                <el-row>
                    <el-form-item :label="item.fieldShow + ':'" v-for="(item, index) in searchTermList" :key="index" v-show="item.isShow == 1">
                        <el-input @keyup.enter.prevent="toClick(item.fieldEntity)" @blur="inblur" @focus="infocus" style="width: 200px" v-if="item.fieldType == 'string' && item.isShow"
                            @change="(val) => { handleChange(val, item.fieldEntity) }" :placeholder="'请输入' + item.fieldShow" v-model.trim="item.value" size="mini" clearable>
                        </el-input>
                        <!-- 开始时间 -->
                        <el-date-picker v-else-if="item.fieldEntity == 'start'" size="mini" v-model="item.value" format="yyyy 年 MM 月 dd 日" @change="(val) => { handleChange(val, item.fieldEntity) }" value-format="timestamp" type="date"
                            placeholder="选择日期"></el-date-picker>
                        <!-- 结束时间 -->
                        <el-date-picker v-else-if="item.fieldEntity == 'end'" @change="changeTime" size="mini" v-model="item.value" format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date" placeholder="选择日期"></el-date-picker>

                        <el-date-picker v-else-if="item.fieldType == 'date' && item.isShow" @change="(val) => { handleChange(val, item.fieldEntity); }" size="mini" v-model="item.value" format="yyyy 年 MM 月 dd 日" value-format="timestamp"
                            type="date" placeholder="选择日期">
                        </el-date-picker>
                        <el-input @keyup.enter.prevent="toClick(item.fieldEntity)" @blur="inblur" @focus="infocus" style="width: 200px" v-else-if="item.fieldType == 'number' && item.isShow"
                            @change="(val) => { handleChange(val, item.fieldEntity) }" :placeholder="'请输入' + item.fieldShow" v-model.number="item.value" clearable size="mini">
                        </el-input>
                        <el-select @keyup.enter.prevent="toClick(item.fieldEntity)" @blur="inblur" @focus="infocus" size="mini" v-else-if="item.fieldType == 'formatter' && item.isShow"
                            @change="(val) => { handleChange(val, item.fieldEntity) }" v-model="item.value" placeholder="请选择">
                            <el-option v-for="matItem in JSON.parse(item.formatterContent)" :key="matItem.key" :label="matItem.key" :value="matItem.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="mini" @click="searchData">查询</el-button>
                    </el-form-item>
                </el-row>
            </el-form>
        </div>
        <!-- 表格 -->
        <el-table ref="moviesTable" height="300" size="mini" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent" @row-dblclick="handleDbSelectClick" @selection-change="handleSelectionChange" style="width: 100%"
            :data="tableData" border @sort-change="handleSortChange">
            <template v-for="(item, index) in Columns">
                <!-- 数字 -->
                <el-table-column v-if="
          item.fieldType == 'formatter' &&
          item.isShow &&
          item.formatterContent
        " align="center" :key="index" :min-width="item.width != null ? item.width : 140" :prop="item.fieldEntity" :sortable="item.isSort" :label="item.fieldShow" :show-overflow-tooltip="true">
                    <!-- 各种状态判断 -->
                    <template slot-scope="scope">
                        <el-tag size="mini" type="primary">{{
              $common.getIsGsp(item.formatterContent, scope.row[item.fieldEntity])
            }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column v-else-if="item.fieldType == 'string' && item.isShow" align="center" :key="index + 'a'" :min-width="item.width != null ? item.width : 120" :prop="item.fieldEntity" :sortable="item.isSort"
                    :label="item.fieldShow" :show-overflow-tooltip="true">
                </el-table-column>
                <el-table-column v-else-if="item.fieldType == 'date' && item.isShow" align="center" :key="index + 'b'" :min-width="item.width != null ? item.width : 120" :prop="item.fieldEntity" :sortable="item.isSort"
                    :label="item.fieldShow" :show-overflow-tooltip="true">
                    <template slot-scope="scope">
                        <span>{{ $common.getLocalTime(scope.row[item.fieldEntity]) }}</span>
                    </template>
                </el-table-column>
                <el-table-column v-else-if="item.fieldType == 'number' && item.isShow" align="center" :key="index + 'c'" :min-width="item.width != null ? item.width : 120" :prop="item.fieldEntity" :sortable="item.isSort"
                    :label="item.fieldShow" :show-overflow-tooltip="true">
                </el-table-column>
            </template>
            <el-table-column v-if="!isDetail" fixed="right" label="操作" width="110" align="center">
                <template slot-scope="scope">
                    <el-button size="mini" type="text" @click.stop="handleSelectClick(scope.row)">确认选择</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页 -->
        <div style="display: flex;align-items: center;">
            <el-pagination v-if="isPagination" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" background :page-size="pageSize"
                layout="total, sizes, prev, pager, next" :total="total">
            </el-pagination>
            <el-switch style="display: block" @change="showDetailChange" v-model="showdetail" active-text="展示明细" inactive-text="关闭明细">
            </el-switch>
            <!-- :disabled="detailsub" -->
            <el-button v-if="isDetail && choiceDetail" size="mini" @click="sureDetail" style="margin-left: 60px" type="primary">确认选择</el-button>
            <el-tag v-else size="mini" style="margin-left: 60px">明细表格</el-tag>
        </div>

        <el-collapse v-model="activeName" accordion>
            <el-collapse-item name="1" :disabled="true">
                <!-- 明细表 -->
                <el-table size="mini" @selection-change="handleSelectionChange1" height="200" :data="detailData" border stripe highlight-current-row :header-cell-style="getHeaderCellStyleD" style="width: 100%">
                    <el-table-column v-if="isDetail && choiceDetail" type="selection" width="40">
                    </el-table-column>
                    <template v-for="(item, index) in ColumnsDetail">
                        <!-- 数字 -->
                        <el-table-column v-if="
              item.fieldType == 'formatter' &&
              item.isShow &&
              item.formatterContent
            " align="center" :key="index" :min-width="item.width != null ? item.width : 120" :prop="item.fieldEntity" :sortable="item.isSort" :label="item.fieldShow" :show-overflow-tooltip="true">
                            <!-- 各种状态判断 -->
                            <template slot-scope="scope">
                                <el-tag size="mini" type="primary">{{
                  $common.getIsGsp(item.formatterContent, scope.row[item.fieldEntity])
                }}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column v-else-if="item.fieldType == 'string' && item.isShow" align="center" :key="index + 'd'" :min-width="item.width != null ? item.width : 120" :prop="item.fieldEntity" :sortable="item.isSort"
                            :label="item.fieldShow" :show-overflow-tooltip="true">
                        </el-table-column>
                        <el-table-column v-else-if="item.fieldType == 'date' && item.isShow" align="center" :key="index + 'e'" :min-width="item.width1 = null ? item.width : 120" :prop="item.fieldEntity" :sortable="item.isSort"
                            :label="item.fieldShow" :show-overflow-tooltip="true">
                            <template slot-scope="scope">
                                <span>{{
                  $common.getLocalTime(scope.row[item.fieldEntity])
                }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column v-else-if="item.fieldType == 'number' && item.isShow" align="center" :key="index + 'f'" :min-width="item.width != null ? item.width : 120" :prop="item.fieldEntity" :sortable="item.isSort"
                            :label="item.fieldShow" :show-overflow-tooltip="true">
                        </el-table-column>
                    </template>
                </el-table>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>
<script>
export default {
    name: "ExtractionSchemeSSDD",
    components: {},
    data() {
        return {
            opmId: "",
            ormId: "",
            detailsub: true,
            activeName: "0",
            showdetail: false,
            detailData: [],
            currentPage: 1,
            pageSizes: [10, 25, 50, 100],
            pageSize: 10,
            total: 0,
            tableData: [],
            isPagination: "",
            queryMap: {},
            searchTermList: [], //检索条件
            Columns: [],
            ColumnsDetail: [],
            isDetail: false,
            multipleSelection: [], //数组内层
            objList: [], //外层数组
            repetId: "",
            selectedRow: [], // 当前已选择行
            selectedIndex: 0, // 当前选择行的index
            clickTimer: null,
            delay: 500 // 延迟时间（毫秒）
        };
    },

    props: {
        id: {
            type: [Number, String],
            require: true,
        },
        ppId: {
            type: [Number, String],
            require: true,
        },
        choiceDetail: {
            type: Boolean,
            require: true,
            default: true
        },
        isOrderSource: {
            type: Boolean,
            require: false,
            default: false
        },
        extractParamsData: {
            type: Object,
            require: false,
        },
        wobkemId: {
            type: [String],
            require: true,
        },
        psbkmId: {
            type: [String],
            require: true,
        },
        coId: {
            type: [Number, String],
            require: true,
            default: () => {
                return ""
            }
        },
        detailsObj: {
            type: [Object],
            require: false,
        },
        interceptFlag: {
            type: [Boolean],
            require: false,
        },
        detailsFlag: {
            type: [Boolean],
            require: false,
        },
        isChecked: {
            type: [Boolean],
            require: false,
        }
    },
    watch: {},
    computed: {},
    created() {
        // 处理组件需要的数据
        this.ormId = JSON.parse(sessionStorage.getItem("loginInfo")).ormId;
        this.opmId = JSON.parse(sessionStorage.getItem("userInfo")).opmId;
        console.log(this.id)
        this.$dbCache.Record_Get(this.id).then(async (val) => {
            let exPlan = val
            if (!exPlan) {
                exPlan = await this.extractQuery();
            }
            console.log(exPlan, this.ormId);
            let {
                pageCount, //分页条目数
                isPagination, //是否分页
                conditionList, //检索信息
                tableMainList, //主表表头信息
                tableDetailList, //明细表头信息
                width, //宽度
                isDetail, // 是否可选择明细
                extractName, //标题
                repetId,
            } = exPlan;
            this.repetId = repetId;
            console.log(conditionList)
            conditionList.forEach((item) => {
                if (item.fieldEntity == 'start') {
                    item.value = new Date(new Date().toLocaleDateString()).getTime() -
                        7 * 24 * 3600 * 1000
                    this.searchData.start = item.value
                } else if (item.fieldEntity == 'end') {
                    item.value = new Date(new Date().toLocaleDateString()).getTime() +
                        24 * 60 * 60 * 1000 - 1
                    this.searchData.end = item.value
                } else if (item.fieldEntity == 'wobkemId') {
                    item.value = this.wobkemId
                    this.searchData.wobkemId = item.value
                } else if (item.fieldEntity == 'psbkmId') {
                    item.value = this.psbkmId
                    this.searchData.psbkmId = item.value
                } else {
                    item.value = "";
                }

                for (let key in this.extractParamsData) {
                    console.log(item.fieldEntity, key, this.extractParamsData[key]);

                    if (item.fieldEntity == key) {
                        item.value = this.extractParamsData[key];
                    }
                }
            });

            for (let key in this.extractParamsData) {
                if (this.extractParamsData[key] == undefined) {
                    this.extractParamsData[key] = ''
                }
            }
            tableMainList.forEach((item) => {
                item.isShow == 1 ? (item.isShow = true) : (item.isShow = false);
                item.isSort == 1 ? (item.isSort = true) : (item.isSort = false);
            });
            tableDetailList.forEach((item) => {
                item.isShow == 1 ? (item.isShow = true) : (item.isShow = false);
                item.isSort == 1 ? (item.isSort = true) : (item.isSort = false);
            });
            this.$emit("getWidth", width);
            this.$emit("sendTitle", extractName);
            this.pageSizes = pageCount.split(",").map(item => Number(item))
            this.isDetail = isDetail == 1 ? true : false
            if (this.isDetail) {
                this.showdetail = true;
                this.activeName = "1";
            } else {
                this.showdetail = false;
                this.activeName = "0";
            }
            this.Columns = tableMainList;
            console.log(this.Columns)
            this.ColumnsDetail = tableDetailList;
            this.searchTermList = conditionList;
            this.isPagination = isPagination == 0 ? false : true; //是否分页
            // 根据返回数据处理一些页面逻辑
            this.pageSize = parseInt(this.pageSizes[0]);
            if (this.isPagination == true) {
                // 添加请求参数
                this.searchTermList.forEach((item) => {
                    if (item.fieldType == 'date') {
                        this.queryMap[item.fieldEntity] = item.value
                        return
                    }
                    this.queryMap[item.fieldEntity] = ''
                });
                // 需要分页
                this.queryMap.extractId = this.id;
                this.queryMap.opmId = this.opmId;
                this.queryMap.ormId = this.ormId;
                this.queryMap.wobkemId = this.wobkemId
                this.queryMap.psbkmId = this.psbkmId
                this.queryMap.page = this.currentPage;
                this.queryMap.rows = this.pageSize;
            } else {
                this.searchTermList.forEach((item) => {
                    if (item.fieldType == 'date') {
                        this.queryMap[item.fieldEntity] = item.value
                        return
                    }
                    this.queryMap[item.fieldEntity] = ''
                });
                this.queryMap.extractId = this.id;
                this.queryMap.opmId = this.opmId;
                this.queryMap.ormId = this.ormId;
                this.queryMap.wobkemId = this.wobkemId
                this.queryMap.psbkmId = this.psbkmId
            }
            for (let qkey in this.queryMap) {
                for (let key in this.extractParamsData) {
                    if (qkey == key) {
                        this.queryMap[qkey] = this.extractParamsData[key];
                    }
                }
            }
            if (this.isOrderSource) {
                this.queryMap.orderSource = '高值'
            }
            this.queryMap.ormId = this.ormId;
            this.getTableMainList(this.queryMap);
        });
    },
    mounted() {
        addEventListener("keyup", this.keyUpChild);
    },
    beforeDestroy() {
        removeEventListener("keyup", this.keyUpChild);
    },
    methods: {
        async extractQuery() {
            const res = await this.$http.extractQueryExtractLinkById({ ids: [this.id] });
            if (res.status == 200) {
                return res.result;
            } else {
                this.$message.error(res.message);
                return {};
            }
        },
        handleSortChange({ column, prop, order }) {
            let refsElTable = this.$refs.moviesTable
            this.tableData.sort((a, b) => {
                if (order === 'ascending') {
                    return a[prop] > b[prop] ? 1 : -1;
                } else if (order === 'descending') {
                    return a[prop] < b[prop] ? 1 : -1;
                } else {
                    return 0;
                }
            });
            this.tableData.forEach((item, index) => {
                item.rowIndex = index
            })
            this.selectedIndex = 0
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(this.tableData[this.selectedIndex]); // 把现在当前行勾选
        },
        toClick(e) {
            this.searchData()
            this.$nextTick(() => {
                this.$refs[e][0].blur()
            })
            // document.getElementById("btn").click()
        },
        inblur() {
            this.$nextTick(() => {
                addEventListener('keyup', this.keyUpChildEnter)
            })
        },
        infocus() {
            removeEventListener('keyup', this.keyUpChildEnter)
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.queryMap.end = time
                // this.queryData.end = time;
            }
        },
        showDetailChange(e) {
            e == true ? (this.activeName = "1") : (this.activeName = "0");
        },
        //   ------------------------------------------------------------
        // 双击主表格确认
        async handleSelectClick(row) {

            // 是否可选择明细
            if (this.isDetail) {
                return this.$message.error("请选择明细");
            }
            let res;
            if (this.tableData && this.tableData.length) {
                let queryMap = {
                    id: row[this.ppId],
                    extractId: this.id,
                };
                if (this.coId) {
                    queryMap.coId = this.coId
                }
                res = await this.$http.queryExtractPlanDetailVo(queryMap);
                this.detailData = res.rows;
                row.arrlistbychen = this.detailData;
                if (this.interceptFlag) {
                    this.$emit("TranData", row);
                    return
                }
                if (!this.repetId) {
                    this.$emit("TranData", row);
                    return
                }
                var ids = row[this.repetId];
                let responseData = await this.$http.checkIsExtract({
                    ids: [ids],
                });
                if (responseData.status == 200) {
                    this.$emit("TranData", row);
                } else {
                    this.$message({
                        message: responseData.message,
                        type: "error",
                    });
                }
            }
        },
        // 勾选明细
        handleSelectionChange1(val) {
            this.multipleSelection = val;
            if (val.length) {
                this.detailsub = false;
            } else {
                this.detailsub = true;
            }
        },
        async sureDetail() {
            if (this.objList['isTb'] == undefined || this.objList['isTb'] != '是') {
                this.sureSelect()
            } else {
                this.$confirm('当前明细存在退补, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.sureSelect()
                }).catch(() => {
                });
            }

        },
        async sureSelect() {
            if (this.multipleSelection.length == 0 && this.detailsFlag) {
                return this.$message.error('请至少选择一条明细')
            }
            this.objList.arrlistbychen = this.multipleSelection;
            if (this.interceptFlag) {
                this.$emit("TranData", this.objList);
                return
            }
            if (!this.repetId) {
                this.$emit("TranData", this.objList);
                return
            }
            var ids = this.objList[this.repetId];
            let responseData = await this.$http.checkIsExtract({
                ids: [ids],
            });
            if (responseData.status == 200) {
                this.$emit("TranData", this.objList);
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 单击表格
        handleClick(row) {
            this.objList = row;
            let queryMap = {
                id: row[this.ppId],
                extractId: this.id,
            };
            this.getTableDetailList(queryMap);
        },
        // 检索条件赋值
        handleChange(value, name) {
            console.log(value, name);
            this.queryMap[name] = value;
        },
        //   查询
        searchData() {
            this.currentPage = 1;
            this.queryMap.page = 1;
            this.detailData = []
            this.getTableMainList(this.queryMap);
        },
        // 查询弹窗表格
        async getTableMainList(params) {
            console.log(this.ppId);

            let res = await this.$http.queryExtractPlanMainVo(params);
            this.total = res.total;
            this.tableData = res.rows; //默认第一条
            // if (this.tableData?.length == 1 && !this.isDetail && this.total == 1) {
            //   this.handleSelectClick(this.tableData[0]);
            //   return
            // }
            if (this.tableData && this.tableData.length) {
                this.objList = this.tableData[0];
                // this.isDetail = this.objList.isOrder == 1? true : false;
                this.showdetail = this.isDetail
                let queryMap = {
                    id: this.tableData[0][this.ppId],
                    extractId: this.id,
                };
                this.getTableDetailList(queryMap);
            } else {
                this.objList = [];
            }
            this.$nextTick(() => {
                if (!this.tableData) return;
                let refsElTable = this.$refs.moviesTable;
                refsElTable.clearSelection();
                refsElTable.toggleRowSelection(this.tableData[this.selectedIndex]);
            });
            this.$refs.moviesTable.doLayout();
        },
        // 获取明细表格
        async getTableDetailList(params, flag) {
            if (this.coId) {
                params.coId = this.coId
            }
            if (this.detailsObj) {
                Object.assign(params, this.detailsObj);
            }
            let res = await this.$http.queryExtractPlanDetailVo(params);
            this.detailData = res.rows;
            if (flag) {
                var obj = JSON.parse(JSON.stringify(this.objList))
                if (this.detailData.length > 0) {
                    this.$set(obj, 'arrlistbychen', this.detailData)
                } else {
                    this.$set(obj, 'arrlistbychen', [])
                }
                this.$emit("TranData", obj);
            }
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.queryMap.rows = val;
            this.getTableMainList(this.queryMap);
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.queryMap.page = val;
            this.selectedIndex = 0
            this.getTableMainList(this.queryMap);
            this.handleClick(this.tableData[this.selectedIndex])
        },
        //   -----------------------------------------------------
        getHeaderCellStyle() {
            return "background: skybule; borderBottom: solid 1px #5a5e66;color: #3e5569";
        },
        getHeaderCellStyleD() {
            return "background: skybule;color: #3e5569";
        },
        keyUpChild(e) {
            // 表格为空，不执行下方
            if (!this.tableData) return;
            e.preventDefault();
            if (e.keyCode == 40) {
                // 下键
                e.preventDefault();
                let refsElTable = this.$refs.moviesTable;
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) {
                        // 如果当前没有选中行，则直接选中第一个
                        this.selectedIndex = 0;
                    } else if (this.selectedIndex == this.tableData.length - 1) {
                        // 如果选中的是最后一行了，那么下一行选中的是第一行
                        this.selectedIndex = 0;
                    } else {
                        // 正常递增
                        this.selectedIndex++;
                    }
                    if (!refsElTable) return;
                    let findRow = this.selectedRow.find(
                        (c) => c.rowIndex == this.selectedIndex
                    ); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(
                            this.tableData[this.selectedIndex],
                            false
                        );
                        return;
                    }
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.tableData[this.selectedIndex]); // 把现在当前行勾选
                    this.handleClick(this.tableData[this.selectedIndex]);
                });
            } else if (e.keyCode == 38) {
                // 上键
                e.preventDefault();
                let refsElTable = this.$refs.moviesTable;
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) {
                        // 当前没有选中行，则直接选中第一个
                        this.selectedIndex = 0;
                    } else if (this.selectedIndex == 0) {
                        // 如果选中的是第一行了，那么下一行选中的是最后一行
                        this.selectedIndex = this.tableData.length - 1;
                    } else {
                        // 正常递减
                        this.selectedIndex--;
                    }
                    if (!refsElTable) return;
                    let findRow = this.selectedRow.find(
                        (c) => c.rowIndex == this.selectedIndex
                    ); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(
                            this.tableData[this.selectedIndex],
                            false
                        );
                        return;
                    }
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(this.tableData[this.selectedIndex]); // 把现在当前行勾选
                    this.handleClick(this.tableData[this.selectedIndex]);
                });
            } else if (e.keyCode == 13) {
                if (this.isDetail) {
                    this.multipleSelection = this.detailData;
                    this.sureDetail();
                } else {
                    this.handleSelectClick(this.tableData[this.selectedIndex]);
                }
            }
        },
        // 表格方法
        rowClassName({
            row,
            rowIndex
        }) {
            let rowName = ""
            let findRow = this.selectedRow.find((c) => c.rowIndex === row.rowIndex);
            if (findRow) {
                rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },
        rowStyle({
            row,
            rowIndex
        }) {
            Object.defineProperty(row, "rowIndex", {
                // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false,
            });
            let rowBackground = {}
            if (row.bgColor && row.bgColor != '') rowBackground.backgroundColor = row.bgColor
            return rowBackground
        },
        clickEvent(row, column, event, params) {
            clearTimeout(this.clickTimer);
            this.clickTimer = setTimeout(() => {
                // 执行单击事件逻辑
                let refsElTable = this.$refs.moviesTable;
                this.selectedIndex = row.rowIndex;
                let findRow = this.selectedRow.find((c) => c.rowIndex == row.rowIndex);
                if (findRow && this.selectedRow.length === 1) {
                    refsElTable.toggleRowSelection(row, false);
                    return;
                }
                refsElTable.clearSelection();
                refsElTable.toggleRowSelection(row);
                this.handleClick(row);
            }, this.delay);
        },
        handleSelectionChange(rows) {
            this.selectedRow = rows; // 保存已选择行
        },
        handleDbSelectClick(row) {
            clearTimeout(this.clickTimer); // 清除单击事件的定时器
            this.objList = row;
            let queryMap = {
                id: row[this.ppId],
                extractId: this.id,
            };
            this.getTableDetailList(queryMap, true);
        },
    },
};
</script>
<style scoped>
.el-pagination {
    padding: 10px 0px 5px;
}

::v-deep .el-collapse-item__header {
    display: none !important;
}

.fixedRight .el-table_fixed-right {
    height: 100%;
}

::v-deep .el-collapse-item__content {
    padding-bottom: 0 !important;
}

::v-deep .el-table td div {
    font-weight: bold !important;
    font-size: 0.95rem !important;
    color: #333 !important;
}
</style>